




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
@Component
export default class NewsList extends Vue {
  @Prop() item: any;
  newsListWindowHref(item: any) {
    if (!window.udid || isWeiXin()) {
      window.location.href = item.titleurl || item.targetUrl;
    } else {
      // window.handleMessage(
      //   JSON.stringify({
      //     action: 'mJump',
      //     data: JSON.stringify({
      //       dt: 3,
      //       cid: item.classId,
      //       nid: item.id,
      //     }),
      //   }),
      // );
      if (item.dataType !== 7) {
        const appNavOption = {
          dt: item.dataType,
          cid: item.classId,
          nid: item.id,
        };
        if (window.handleMessage) {
          window.handleMessage(
            JSON.stringify({
              action: 'mJump',
              data: JSON.stringify(appNavOption),
            }),
          );
        }
      } else if (item.dataType === 7) {
        const appNavOption = {
          dt: 7,
          url: item.targetUrl,
        };
        if (window.handleMessage) {
          window.handleMessage(
            JSON.stringify({
              action: 'mJump',
              data: JSON.stringify(appNavOption),
            }),
          );
        }
      }
    }
  }
}
